import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { changePhoneNumber, transfer } from 'store/actions/call'
import PhoneKeypad, { TYPES } from 'components/pages/dialpad/components/PhoneKeypad'
import PhoneInput from 'components/pages/dialpad/components/PhoneInput'
import Webphone from 'common/Webphone'
import { closeAllModals, toggleKeypadModalVisible } from 'store/actions/global'

export const Keypad = () => {
    const dispatch = useDispatch()
    const [inputValue, setInputValue] = useState('')
    const { calls } = useSelector((state) => state.call)
    const { addNumberModalVisible, transferModalVisible } = useSelector((state) => state.global)

    // Computed
    const currentCall = calls.find((item) => item.isActive)
    const keypadType = (() => {
        if (addNumberModalVisible) {
            return TYPES.ADD
        }
        if (transferModalVisible) {
            return TYPES.TRANSFER
        }
        return TYPES.DTMF
    })()

    // Actions
    const closeAll = () => {
        dispatch(closeAllModals())
    }
    const toggleKeypad = () => dispatch(toggleKeypadModalVisible())
    const addInputValue = (value) => {
        setInputValue(`${inputValue}${value}`)
    }
    const fillInputValue = (value) => {
        setInputValue(value || '')
    }

    function usePrevious(value) {
        const ref = useRef()
        useEffect(() => {
            ref.current = value
        })
        return ref.current
    }

    const prevValue = usePrevious(inputValue)

    useEffect(() => {
        if (keypadType === TYPES.DTMF && currentCall) {
            if (prevValue !== inputValue) {
                Webphone.dtmf(currentCall.number, inputValue.slice(-1))
            }
        }
    }, [inputValue, currentCall, prevValue, keypadType])

    const resetInputValue = () => setInputValue('')
    const onBackspace = () => setInputValue(inputValue.slice(0, -1))
    const onCallHandler = () => {
        if (inputValue?.length > 2) {
            switch (keypadType) {
                case TYPES.CALL:
                case TYPES.ADD:
                    dispatch(changePhoneNumber({ number: inputValue }))
                    break
                case TYPES.TRANSFER:
                    dispatch(transfer({ transferingNumber: currentCall.number, transferToNumber: inputValue }))
                    break
                default:
                    break
            }
            closeAll()
        }
    }

    const onClickCancel = () => {
        if (currentCall && !currentCall.isFinished) {
            Webphone.hangup(currentCall.number)
        }
    }

    useEffect(() => {
        dispatch(changePhoneNumber({ number: '' }))
    }, [dispatch])

    return (
        <div className="dialpad__keypad-page">
            <PhoneInput value={inputValue} onChange={fillInputValue} onReset={resetInputValue} />
            <PhoneKeypad
                {...{
                    addInputValue,
                    onBackspace,
                    onCallHandler,
                    onClickCancel,
                    toggleKeypad,
                    keypadType
                }}
            />
        </div>
    )
}
